import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RegistryModal from './RegistryModal';
import './Confirmation.css';

function Confirmation({ data }) {
  const navigate = useNavigate();
  const [orderNum] = useState(() => Math.floor(Math.random() * 900) + 100);
  const [showRegistry, setShowRegistry] = useState(false);

  // const getCurrentDate = () => {
  //   const today = new Date();
  //   return today.toLocaleDateString('en-US', {
  //     month: '2-digit',
  //     day: '2-digit',
  //     year: 'numeric'
  //   });
  // };

  // const getCurrentTime = () => {
  //   const now = new Date();
  //   return now.toLocaleTimeString('en-US', {
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: true
  //   });
  // };

  return (
    <div className="confirmation-container">
      <div className="receipt-wrapper">
        <div className="receipt">
          <div className="receipt-header">
            <div className="store-name">BABY SHOWER</div>
            <div className="store-tagline">One cutie pie coming soon!</div>
            <div className="store-address">13954 Hamlin St.</div>
            <div className="store-address">Valley Glen, CA 91401</div>
            <div className="receipt-divider">================================</div>
            <div className="receipt-info">ORDER #{orderNum}</div>
            {/* <div className="receipt-info">DATE: {getCurrentDate()}</div>
            <div className="receipt-info">TIME: {getCurrentTime()}</div> */}
            <div className="receipt-divider">================================</div>
          </div>

          <div className="order-confirmation">
            <div className="confirmation-status">
              <span className="checkmark">✓</span>
              <span className="status-text">ORDER CONFIRMED</span>
            </div>
          </div>

          {/* <div className="section-title">ORDER DETAILS</div>

          <div className="order-items">
            <div className="item-line">
              <span>FOOD & TREATS</span>
              <span className="dots"></span>
              <span>$YUMMY</span>
            </div>
            <div className="item-line">
              <span>DRINKS</span>
              <span className="dots"></span>
              <span>$GREAT</span>
            </div>
            <div className="item-line">
              <span>FUN & GAMES</span>
              <span className="dots"></span>
              <span>$5.00</span>
            </div>
          </div> */}

          <div className="section-title">GUEST INFORMATION</div>

          <div className="guest-details">
            <div className="detail-line">
              <span className="label">NAME:</span>
              <span className="value">{data.name}</span>
            </div>
            <div className="detail-line">
              <span className="label">EMAIL:</span>
              <span className="value">{data.email}</span>
            </div>
            {data.phone && (
              <div className="detail-line">
                <span className="label">PHONE:</span>
                <span className="value">{data.phone}</span>
              </div>
            )}
            <div className="detail-line">
              <span className="label">ATTENDING:</span>
              <span className={`value ${data.attending === 'yes' ? 'attending-yes' : 'attending-no'}`}>
                {data.attending === 'yes' ? '✓ YES' : '✗ NO'}
              </span>
            </div>
            {data.attending === 'yes' && (
              <>
                <div className="detail-line">
                  <span className="label">ADULTS:</span>
                  <span className="value">{data.adults}</span>
                </div>
                {data.kids > 0 && (
                  <div className="detail-line">
                    <span className="label">KIDS:</span>
                    <span className="value">{data.kids}</span>
                  </div>
                )}
              </>
            )}
          </div>

          {data.message && (
            <>
              <div className="section-title">MESSAGE FOR MOM</div>
              <div className="message-box">
                "{data.message}"
              </div>
            </>
          )}

          <div className="total-section">
            {/* <div className="total-line">
              <span>SUBTOTAL:</span>
              <span>$AMAZING</span>
            </div>
            <div className="total-line">
              <span>JOY & LOVE:</span>
              <span>$INFINITE</span>
            </div>
            <div className="receipt-divider">================================</div> */}
            <div className="total-line grand-total">
              <span>TOTAL:</span>
              <span>{data.adults + data.kids}</span>
            </div>
          </div>

          <div className="event-reminder">
            <div className="section-title">EVENT DETAILS</div>
            <div className="event-info">
              <div className="event-line">
                <span className="label">DATE:</span>
                <span>MARCH 14, 2026</span>
              </div>
              <div className="event-line">
                <span className="label">TIME:</span>
                <span>2:00 PM</span>
              </div>
              <div className="event-line">
                <span className="label">LOCATION:</span>
                <span>13954 HAMLIN ST.</span>
              </div>
              <div className="event-line">
                <span></span>
                <span>VALLEY GLEN, CA 91401</span>
              </div>
            </div>
          </div>

          <div className="registry-section">
            <div className="section-title">BABY REGISTRY</div>
            <button
              className="registry-link"
              onClick={() => setShowRegistry(true)}
            >
              VIEW REGISTRIES 🎁
            </button>
          </div>

          <div className="contact-section">
            <div className="contact-label">QUESTIONS? CONTACT</div>
            <div className="contact-info">Patrisha & Bryan — (818) 324-6789</div>
          </div>

          <div className="receipt-footer">
            <div className="thank-you-message">
              THANK YOU FOR YOUR RSVP!
            </div>
            <div className="footer-message">
              CAN'T WAIT TO CELEBRATE WITH YOU!
            </div>
            <div className="barcode" aria-hidden="true"></div>
            <div className="receipt-number">RECEIPT #{orderNum}-{data.name.substring(0,3).toUpperCase()}</div>
          </div>

          <button
            className="back-button"
            onClick={() => navigate('/')}
          >
            ← BACK TO INVITATION
          </button>
        </div>
      </div>

      {showRegistry && <RegistryModal onClose={() => setShowRegistry(false)} />}
    </div>
  );
}

export default Confirmation;
